import axios from "axios";
import { API_URL } from "../constant/Constant";
import { jwtDecode } from "jwt-decode";


const AuthService = {
    login: (data) => axios.get(API_URL + "authentication/token", {headers: {"Content-Type": "application/json", "email": data.email, "password": data.password}}),
    register: (data) => axios.post(API_URL + "authentication/signup", data),
    isTokenExpired: (token) => {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if(decodedToken.exp < currentTime){
            return true;
        }else{
            return false;
        }
    },
    refresh: (refreshToken) => axios.get(API_URL + "authentication/refresh", {headers: {"Content-Type": "application/json", "refreshToken": refreshToken}}),
    sendOtp: (data) => axios.post(API_URL + "authentication/forgotPassword/sendOtp", data),
    verifyOtp: (data) => axios.post(API_URL + "authentication/forgotPassword/verifyOtp", data),
};

export default AuthService;